import React from 'react';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Facebook from '../../../assets/images/Facebook.png';
import LinkedIn from '../../../assets/images/LinkedIn.png';
import Twitter from '../../../assets/images/Twitter.png';

const socials = [
  {
    id: 1,
    img: Facebook,
    url: 'https://www.facebook.com/castlelearning/'
  },
  {
    id: 2,
    img: LinkedIn,
    url: 'https://www.linkedin.com/company/castlelearning/'
  },
  {
    id: 3,
    img: Twitter,
    url: 'https://twitter.com/castlelearning/'
  }
];

const ContactUs = () => {
  return (
    <div className="col-lg-6">
      <div className="contact-us">
        <h4 className="mb-3">Contact Us </h4>
        <p>
          {' '}
          <FontAwesomeIcon icon={faPhone} style={{paddingRight:'5px'}}/>
          <a href="tel:1-800-345-7606" className="linkto">1-800-345-7606</a>
        </p>
        <p>
          {' '}
          <FontAwesomeIcon icon={faEnvelope} style={{paddingRight:'5px'}}/>
          <a href="mailto:support@castlelearning.com" className="linkto">support@castlelearning.com</a>
        </p>
        <h6 className="mb-3">Follow Us On</h6>
        <div className="d-flex gap-2">
          {socials.map((item, index) => (
            <a key={index} target="_blank" href={item.url} rel="noreferrer">
              <img src={item.img} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
